import React from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./lib/auth";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import CommandCenter from "./pages/CommandCenter";
import Agents from "./pages/Agents";
import Intelligence from "./pages/Intelligence";
import Influencers from "./pages/Influencers";
import Studio from "./pages/Studio";
import Campaigns from "./pages/Campaigns";
import Calendar from "./pages/Calendar";
import Analytics from "./pages/Analytics";
import Settings from "./pages/Settings";
import Wallet from "./pages/Wallet";
import AppShell from "./components/layout/AppShell";

function Protected({ children }) {
  const { user } = useAuth();
  const loc = useLocation();
  if (!user) return <Navigate to="/login" state={{ from: loc }} replace />;
  return <AppShell>{children}</AppShell>;
}

function SuperAdminOnly({ children }) {
  const { user } = useAuth();
  const loc = useLocation();
  if (!user) return <Navigate to="/login" state={{ from: loc }} replace />;
  if (user.role !== "super_admin") return <Navigate to="/app/studio" replace />;
  return <AppShell>{children}</AppShell>;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster
          theme="light"
          position="bottom-right"
          toastOptions={{
            style: {
              background: "#ffffff",
              border: "1px solid #e2e8f0",
              color: "#0f172a",
              fontFamily: "'Instrument Sans', sans-serif",
              borderRadius: "8px",
              boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
            },
          }}
        />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          {/* Brand workspace — visible to brand_owner + super_admin */}
          <Route path="/app" element={<Protected><Studio /></Protected>} />
          <Route path="/app/studio" element={<Protected><Studio /></Protected>} />
          <Route path="/app/influencers" element={<Protected><Influencers /></Protected>} />
          <Route path="/app/campaigns" element={<Protected><Campaigns /></Protected>} />
          <Route path="/app/calendar" element={<Protected><Calendar /></Protected>} />
          <Route path="/app/wallet" element={<Protected><Wallet /></Protected>} />
          <Route path="/app/analytics" element={<Protected><Analytics /></Protected>} />
          <Route path="/app/settings" element={<Protected><Settings /></Protected>} />
          {/* Super-admin operator surfaces */}
          <Route path="/app/admin" element={<SuperAdminOnly><CommandCenter /></SuperAdminOnly>} />
          <Route path="/app/agents" element={<SuperAdminOnly><Agents /></SuperAdminOnly>} />
          <Route path="/app/intelligence" element={<SuperAdminOnly><Intelligence /></SuperAdminOnly>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
